
import { AppThunk, axiosInstance, getHeaders } from '@share/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILuxuryHomeDetailsRate } from '@share/common-types';
import { Urls } from '@share/constants';

export interface IluxuryHomesDetailsState {
  rates: ILuxuryHomeDetailsRate | null;
  unavailableDates: string[];
  error: string;
  isLoading: boolean;
}

export const luxuryHomesDetailsInitialState: IluxuryHomesDetailsState = {
  rates: null,
  unavailableDates: [],
  error: '',
  isLoading: false,
};

const luxuryHomesDetailsSlice = createSlice({
  name: 'luxury-homes',
  initialState: luxuryHomesDetailsInitialState,
  reducers: {
    setRates: (state: IluxuryHomesDetailsState, { payload }: PayloadAction<ILuxuryHomeDetailsRate | null>) => {
      state.rates = payload;
    },
    setUnavailableDates: (state: IluxuryHomesDetailsState, { payload }: PayloadAction<string[]>) => {
      state.unavailableDates = payload;
    },
    setError: (state: IluxuryHomesDetailsState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setLoading: (state: IluxuryHomesDetailsState, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setDefaultValues: () => {
      return luxuryHomesDetailsInitialState;
    },
  },
});

export const luxuryHomesDetailsActions = luxuryHomesDetailsSlice.actions;

export const luxuryHomesDetailsReducer = luxuryHomesDetailsSlice.reducer;

export const getluxuryHomesDetailsRates = (propertyId: number): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(luxuryHomesDetailsActions.setLoading(true));

      const { data } = await axiosInstance.get(`${Urls.LuxuryHomesDetailsRates}/${propertyId}/rates`, {
        ...getHeaders(),
      });

      dispatch(luxuryHomesDetailsActions.setRates(data));

      const unavailableDates = data?.days?.filter((day: any) => day?.isAvailable === false).map((day: any) => day?.date);
      dispatch(luxuryHomesDetailsActions.setUnavailableDates(unavailableDates));

      dispatch(luxuryHomesDetailsActions.setLoading(false));
    } catch (error: any) {
      dispatch(luxuryHomesDetailsActions.setLoading(false));
      dispatch(luxuryHomesDetailsActions.setError(error.toString()));
    }
  };
};
